import { render, staticRenderFns } from "./NewConversationContactsPage.vue?vue&type=template&id=2842eff6&scoped=true"
import script from "./NewConversationContactsPage.vue?vue&type=script&lang=js"
export * from "./NewConversationContactsPage.vue?vue&type=script&lang=js"
import style0 from "./NewConversationContactsPage.vue?vue&type=style&index=0&id=2842eff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2842eff6",
  null
  
)

export default component.exports